module.exports = __webpack_public_path__ + "img/installations OneB Mapper_1.179abf83.jpg";